import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import parseEvent from './helpers/parseEvent';
import { netEntParseEvent, netEntParseEventWeb } from './helpers/netEntParseEvent';
import store from '../../state/store';
import { addXp } from '../../state/slices/xp/xp';
import { addCoins, setCoin, subtractCoins, setLastWin } from '../../state/actions/extras';
import { tooltipDetails, shouldShowTooltip } from '../../state/actions/tooltip';
import { clearOnboarding, setOnboardingFtueStep, setOnboardingHighlightedPosition } from '../../state/actions/currentOnboarding';
import { setLastTimeRatingSeen } from '../../state/actions/playerInfo';
import jsonParser, { Name as jsonParserName } from './helpers/jsonParser';
import kvpParser, { Name as kvpParserName } from './helpers/KeyValuePairParser';
import { getLevelUpData } from '../../state/query/levelUp';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens/index';
import ShowRateUs from '../../utils/ShowRateUs';
import Logger from '../../lib/analytics/logger';
import Utils from '../../utils/game';
import appUtils from '../../utils/';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { TooltipTypes } from '../../utils/tooltipConstants';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { FLAG_DEFAULT_VALUES } from '../../utils/featureFlags/constants';
import generalUtils from '../../utils';
import { getText, TEXT_KEY } from '../../utils/localization';
import ERROR_CODE from '../../utils/errorCodes';

/**
 * @class
 * @virtual
 * Base class for interacting with games. Implements common functionality and helpers.
 * This class should not be used directly. Instantiate a subclass according to the game provider.
 */
var GameInterface = /*#__PURE__*/function () {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function GameInterface(args) {
    var _this = this;
    _classCallCheck(this, GameInterface);
    this._dispatcher = null;
    this._exitFunc = function () {};
    this.messageHandle = function (message, provider) {
      var event;
      switch (provider) {
        case 'netent':
          if (appUtils.getPlatform() !== 'web') {
            event = netEntParseEvent(message, _this.parsers);
          } else {
            event = netEntParseEventWeb(message, _this.parsers);
          }
          break;
        default:
          event = parseEvent(message, _this.parsers);
          break;
      }
      if (event) {
        _this.receivedEvent(event);
      }
    };
    /**
     * Generic JSON Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    this.jsonParserEvent = function (event) {
      console.warn("Unhandled JSONParserEvent: ".concat(JSON.stringify(event)));
    };
    /**
     * Generic KVP Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    this.kvpParserEvent = function (event) {
      console.warn("Unhandled kvpParserEvent: ".concat(JSON.stringify(event)));
    };
    /**
     * Send an event to the iframe.
     * @param {Object} message Data to send.
     */
    this.sendEvent = function (message) {
      if (_this._dispatcher != null) {
        _this._dispatcher(message);
      }
    };
    /**
     * Send an event.
     */
    this.sendAnalyticEvent = function () {
      var _store$getState$gameI = store.getState().gameInfo,
        gameId = _store$getState$gameI.gameId,
        gameType = _store$getState$gameI.gameType;
      var trigger = Logger.getActionTrigger();
      var unlockLevel = Utils.getUnlockLevel(gameId, gameType);
      var isFeatured = Utils.isFeaturedGame(gameId) ? 'true' : 'false';
      if (!unlockLevel) return;
      var eventPayload = {
        trigger: trigger,
        game_type: gameType,
        is_featured: isFeatured,
        unlock_level: unlockLevel.UNLOCK_LEVEL
      };
      if (!_this.hasSentGameLoadedEvent) {
        Logger.sendEvent(EVENT_TYPES.GAME_LOADED, eventPayload);
        _this.hasSentGameLoadedEvent = true;
      }
    };
    this.sendErrorCreatedEvent = function (errorDescription) {
      var _store$getState$gameI2 = store.getState().gameInfo,
        gameId = _store$getState$gameI2.gameId,
        gameType = _store$getState$gameI2.gameType;
      var eventPayload = {
        game_id: gameId,
        game_provider: gameType,
        description: errorDescription,
        code: 1
      };
      Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
    };
    this.syncCoinsBalance = function (balance) {
      var _getFeatureConfig;
      var _useFeatureFlags = useFeatureFlags(),
        getFeatureConfig = _useFeatureFlags.getFeatureConfig;
      var syncCoins = (_getFeatureConfig = getFeatureConfig(FLAG_DEFAULT_VALUES.fe_provider_sync_coins)) === null || _getFeatureConfig === void 0 ? void 0 : _getFeatureConfig.enabled;
      syncCoins && store.dispatch(setCoin(balance));
    };
    /** Callback that child classes can use post dispatcher attachment */
    this.dispatcherAttached = function () {};
    this.getBetInfo = function () {};
    /**
     * Add XP to the local store.
     * If we've gained enough for a level, also trigger that.
     * @param {Number} amount The amount of XP to add.
     */
    this.AddLocalXP = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(amount) {
        var state, currentXp, xpRequired;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              state = store.getState();
              currentXp = state.xpInfo.xp;
              xpRequired = state.xpInfo.xpRequired;
              console.log("Adding ".concat(amount, " XP. New XP: ").concat(currentXp + amount, "/").concat(xpRequired));
              store.dispatch(addXp(amount));

              // If this was enough xp to level up
              if (!(currentXp + amount >= xpRequired)) {
                _context.next = 14;
                break;
              }
              _context.prev = 6;
              _context.next = 9;
              return store.dispatch(getLevelUpData.initiate({}, {
                forceRefetch: true
              })).unwrap();
            case 9:
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](6);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0),
                code: ERROR_CODE.LEVEL_UP_ERROR
              });
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 11]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * Add XP to the local store based on bet amount.
     * Convenience method for AddLocalXP.
     */
    this.AddSpinXP = function (bet) {
      var state = store.getState();
      var coinAmount = parseInt(state.coin.value);
      if (coinAmount >= parseInt(bet)) {
        _this.AddLocalXP(_this.GetSpinXP(bet));
      }
    };
    /**
     * Helper method to return how much XP will be awarded for a spin
     * with given bet amount.
     * This amount is equal to the base XP per spin, plus the bet * multiplier;
     * @param {Number} bet How much the player is betting.
     */
    this.GetSpinXP = function (bet) {
      var state = store.getState();
      var baseSpinXp = state.xpInfo.xpPerSpin;
      var multiplier = state.xpInfo.xpBetMultiplier;
      var wagerBetMultiplier = 1;
      // if (betData.bonusXP && _lastPlayerBet >= betData.bonusXPThreshold) {
      //   wagerBetMultiplier = parseFloat(betData.bonusXP.multiplier)
      // }
      return (baseSpinXp + multiplier * bet) * wagerBetMultiplier;
    };
    this.CreditCoins = function (amount) {
      store.dispatch(addCoins(amount));
    };
    this.DebitCoins = function (amount) {
      var coinBalance = store.getState().coin.value;
      if (parseInt(coinBalance) >= parseInt(amount)) {
        store.dispatch(subtractCoins(amount));
      }
    };
    this.showOutOfCoinsScreen = function () {
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.OutOfCoin));
      var outOfCoins = store.getState().consumables.outOfCoins;
      var eventPayload = {
        product_id: outOfCoins.CURRENCY_ITEM_ID,
        amount: outOfCoins.PRICE
      };
      Logger.sendEvent(EVENT_TYPES.OOC_POP_UP_SHOWED, eventPayload);
    };
    this.GetLastWin = function () {
      return store.getState().lastWin.value;
    };
    this.SetLastWin = function (amount) {
      store.dispatch(setLastWin(amount));
    };
    this.showRateUsScreen = function () {
      var lastTimeRatePopup = store.getState().playerInfo.lastTimeRated;
      var newTime = new Date();
      var timeLimit = 86400000; // 24 * 60 * 60 * 1000 = 24 hours in ms;
      var timeDiff = !lastTimeRatePopup ? 0 : newTime - new Date(lastTimeRatePopup);
      if (timeDiff > timeLimit || timeDiff === 0) {
        ShowRateUs();
        store.dispatch(setLastTimeRatingSeen(newTime));
      }
    };
    this.showFtuePopUpAnimation = function () {
      var style = null;
      if (generalUtils.getPlatform() === 'web') {
        var currentStopElm = document.getElementsByClassName('LevelBar');
        if (currentStopElm) {
          currentStopElm = currentStopElm[0];
          style = currentStopElm.getBoundingClientRect();
        }
      }
      var _tooltipDetails = generalUtils.getPlatform() === 'web' ? {
        title: getText(TEXT_KEY.FTUE_LEVEL_UP_TO_GET),
        animationState: 'AnimationSlideFromTop',
        style: {
          display: 'flex',
          top: '12vh',
          left: style ? style.x + 40 : '15%',
          height: 160,
          zIndex: 400
        },
        showDivider: true,
        popUpType: TooltipTypes.FTUE
      } : {
        title: getText(TEXT_KEY.FTUE_LEVEL_UP_TO_GET),
        source: {},
        ibw: {},
        iconType: null,
        animationState: 'in',
        containerStyle: {
          width: _this._RFValue(215),
          height: _this._deviceInfo.isTablet() ? _this._RFValue(82) : _this._RFValue(100),
          top: _this._deviceInfo.isTablet() ? '10%' : '17%',
          left: _this._deviceInfo.isTablet() ? '6%' : '10%'
        },
        children: null,
        showDivider: true,
        popUpType: TooltipTypes.FTUE
      };
      store.dispatch(tooltipDetails(_tooltipDetails));
      store.dispatch(shouldShowTooltip(true));
      setTimeout(function () {
        _tooltipDetails.animationState = generalUtils.getPlatform() === 'web' ? 'AnimationSlideToTop' : 'out';
        store.dispatch(tooltipDetails(_tooltipDetails));
        setTimeout(function () {
          store.dispatch(shouldShowTooltip(false));
        }, 800);
      }, 5000);
    };
    this.checkFtueStep = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var ftueStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      if (!state) {
        store.dispatch(clearOnboarding());
        _this.showFtuePopUpAnimation();
        return;
      }
      store.dispatch(setOnboardingFtueStep(ftueStep));
      if (position) store.dispatch(setOnboardingHighlightedPosition(position, message));
    };
    this._deviceInfo = args.deviceInfo;
    this._RFValue = args.RFValue;
    this._dimension = args.dimension;
    this._exitFunc = args.ExitFunc;
    this._betInfo = args.BetInfo;
    this._betInfoSent = false;
    this._gameReady = args.GameReady;
    this._outOfCoins = args.OutOfCoins;
    this.showSpinEffect = false;
    this.timer = null;
    this.gameType = args.gameType;
    this.embedData = args.embedData;
    var storeState = store.getState();
    this.soundSettings = {
      soundEffects: storeState.playerInfo.soundEffects,
      music: storeState.playerInfo.music
    };
  }
  return _createClass(GameInterface, [{
    key: "receivedEvent",
    value:
    /**
     * @virtual
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    function receivedEvent(event) {
      switch (event._from) {
        case jsonParserName:
          {
            this.jsonParserEvent(event.payload);
            break;
          }
        case kvpParserName:
          {
            this.kvpParserEvent(event);
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: "sendKeyValuePair",
    value:
    /**
     * Convenience method to send a kvp via sendEvent
     * @param {String} key
     * @param {String} value
     */
    function sendKeyValuePair(key) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var msg = "".concat(key.toString().toUpperCase(), ":").concat(value !== null ? value.toString().toUpperCase() : '');
      this.sendEvent(msg);
    }
  }, {
    key: "dispatcher",
    get: function get() {
      return this._dispatcher;
    },
    set:
    /**
     * Set this dispatcher that will post the message back to the game.
     * If already set, this is a no-op.
     */
    function set(value) {
      if (this._dispatcher === null) {
        this._dispatcher = value;
        this.dispatcherAttached();
      }
    }
  }, {
    key: "exitFunc",
    get: function get() {
      return this._exitFunc;
    }

    /**
     * @virtual
     * Define which parsers the wrapper should use.
     */
  }, {
    key: "parsers",
    get: function get() {
      return [jsonParser, kvpParser];
    }

    /**
     * @virtual
     * Which quest actions can this game interface support?
     * Used for determining best quest to show on tracker.
     */
  }, {
    key: "trackableActions",
    get: function get() {
      return [];
    }
  }]);
}();
export default GameInterface;